import React from "react";

export default function ScheduleCallIco() {
  return (
    <svg
      width="17"
      height="12"
      viewBox="0 0 17 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 3.33333C0 1.49238 1.49238 0 3.33333 0H9.16667C11.0076 0 12.5 1.49238 12.5 3.33333V3.39309L15.1683 1.85923C15.8349 1.47601 16.6667 1.95723 16.6667 2.7262V8.95733C16.6667 9.68358 15.9169 10.1677 15.255 9.86867L12.4879 8.61875C12.3432 10.3261 10.9115 11.6667 9.16667 11.6667H3.33333C1.49238 11.6667 0 10.1742 0 8.33333V3.33333ZM12.5 6.79533L15 7.92467V3.87839L12.5 5.3155V6.79533ZM10.8333 3.33333C10.8333 2.41286 10.0872 1.66667 9.16667 1.66667H3.33333C2.41286 1.66667 1.66667 2.41286 1.66667 3.33333V8.33333C1.66667 9.25383 2.41286 10 3.33333 10H9.16667C10.0872 10 10.8333 9.25383 10.8333 8.33333V3.33333Z"
        fill="#7F56D9"
      />
    </svg>
  );
}
